import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import ReadMore from "@shared/components/ui-kit/typography/ReadMore/ReadMore.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";

interface DonationsCauseDetailsProps {
  causeName: string;
  isLoading: boolean;
  isError: boolean;
  donationsVerbiage?: string;
  charityRefNo?: string;
  charityWebsiteUrl?: string;
}
export default function DonationsCauseDetails({
  causeName,
  isLoading,
  isError,
  donationsVerbiage,
  charityRefNo,
  charityWebsiteUrl,
}: DonationsCauseDetailsProps) {
  const { t } = useTranslation("common");

  return (
    <Box mt="md">
      <Flex direction="column">
        <Box>
          <Text as="h4" fontWeight="bold">
            {causeName ?? ""}
          </Text>
          <Text color="gray.600" fontSize="md">
            {charityWebsiteUrl ?? ""}
          </Text>
        </Box>

        {charityRefNo && (
          <Flex
            direction={{ base: "column", md: "row" }}
            gap={{ base: "none", md: "2" }}
          >
            <Text color="gray.600" fontSize="sm">
              {t("Business number:")}
            </Text>
            <Text color="gray.600" fontSize="sm">
              {charityRefNo}
            </Text>
          </Flex>
        )}
      </Flex>

      <Box mt="lg">
        {!isLoading && !isError && donationsVerbiage && (
          <ReadMore
            openReadMoreText={t("Read more")}
            closeReadMoreText={t("Show less")}
            descriptionHtml={donationsVerbiage}
            descriptionColor="fg"
          />
        )}
      </Box>
    </Box>
  );
}
